import { compose, setDisplayName } from 'react-recompose';

import withReduxDataLoading, { withLoadingBranch } from '~/views/enhancers/withReduxDataLoading.js';

import { fetchOrganization } from '~/state/ducks/organizations/operations.js';
import { getOrgData } from '~/state/ducks/organizations/selectors.js';

import PortalView from '../components/PortalView.jsx';


export default compose(
    setDisplayName('OrganizationsViewContainer'),
    withReduxDataLoading({
        name: 'fetchOrganization',
        operation: ({ match: { params: { id } } }) => fetchOrganization(id),
        selector: getOrgData,
    }),
    withLoadingBranch,
)(PortalView);
